<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="w-96">
      <el-date-picker
        v-model="filters.year"
        type="year"
        placeholder="选择年"
        value-format="yyyy"
        :picker-options="pickerOptions1"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item class="select_btn_170">
      <el-cascader
        class="select_btn_style"
        v-model="filters.trainTypeList"
        :options="trainTypeData"
        :props="props"
        collapse-tags
        placeholder="班级分类"
      >
      </el-cascader>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.className"
        placeholder="班级名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { tranTypeList } from "@/api/class";
import { treeChildVos } from "@/api/classOffline";

export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: {},
      pickerOptions1: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date("2010-01-01") ||
            time.getTime() > new Date()
          );
        },
      },
      options: [],
      trainTypeData: [],
      props: {
        //树形
        multiple: true,
        value: "key",
        label: "name",
        children: "children",
      },
    };
  },
  created() {
    tranTypeList().then(({ code, data }) => {
      if (code === 0) {
        this.options = data;
      }
    });
    treeChildVos({ type: "CLASS_TYPE" }).then((res) => {
      if (!res || res.code != 0) return;
      this.trainTypeData = res.data;
    });
  },
  methods: {
    initData() {
      const filters = { ...this.filters }
      if (filters.trainTypeList && filters.trainTypeList.length) {
        const trainTypeList = new Set()
        filters.trainTypeList.forEach(item => {
          trainTypeList.add(item[1])
        })
        filters.trainTypeList = Array.from(trainTypeList)
      }
      this.$emit("search", filters);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", this.filters);
    },
  },
};
</script>

<style lang="scss" scoped>
.w-96 {
  // width: 96px;
  /deep/ .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 120px;
  }
}
</style>
